<template>
  <el-dialog title="用章申请" :visible.sync="show" :before-close="close" destroy-on-close center>
    <el-form ref="addForm" :model="addInfo" label-width="35%" :rules="rules">
      <el-form-item label="编号" prop="eventId" v-if="type !== 'new'">
        <el-input disabled placeholder="编号" show-word-limit v-model="addInfo.eventId" />
      </el-form-item>
      <el-form-item label="公司">
        <el-select v-model="companyId" placeholder="请选择公司" clearable style="width:100%"
          disabled>
          <el-option v-for="item in companyValueList" :key="item.companyId" :label="item.companyName"
            :value="item.companyId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属部门" prop="deptName" :rules="{ required: true, message: '请选择部门', trigger: 'change' }">
          <el-select style="width: 100%" clearable id="selectInput" @clear="dataFilter" :disabled="type !== 'new'" v-model="addInfo.deptName" filterable placeholder="请选择/输入" ref="searchSelect" :filter-method="(val) => dataFilter(val)">
            <el-option v-for="item in deptNameList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="文本类型" prop="contractCategory">
        <el-select v-model="addInfo.contractCategory" style="width: 100%" :disabled="type !== 'new'" @change="categoryChange">
          <el-option v-for="(item, index) in categoryOptions" :key="index" :label="item.label" :value="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item label="用章类型" prop="stampType">
        <el-select v-model="addInfo.stampType" multiple style="width: 100%" :disabled="type !== 'new'">
          <el-option v-for="(item, index) in sealList" :key="index" :label="item.label" :value="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="showRelatedContractInput" label="关联合同" prop="relatedContract">
        <!-- <el-select 
          v-model="addInfo.relatedContract" 
          filterable 
          placeholder="请选择"
          @change="queryContractNature(addInfo.relatedContract)"
        >
          <el-option
            v-for="item in contractList"
            :key="item.label"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select> -->
        <el-input
          :disabled="type !== 'new'"
          v-model="addInfo.relatedContract"
          placeholder="请输入关联合同号"
          @change="queryContractNature(addInfo.relatedContract)"
        />
        <p v-if="isWarningContract" style="color: red;line-height: 20px;">该合同为预警合同!!!</p>
      </el-form-item>
       <el-form-item v-if="showTotalAmount" label="合同总金额" prop="price">
        <el-input-number style="width: 100%" :disabled="type !== 'new'" v-model="addInfo.price" :precision="2" @change="totalAmountWaring" :controls="false" :step="0.1" :max="99999999.99"> <template slot="append">元</template> </el-input-number>
        <!-- <el-input 
          :disabled="type !== 'new'" 
          placeholder="请输入总金额"
          v-model="addInfo.price"
          :maxlength="11"
          clearable
          @change="totalAmountWaring"
        >
          <template slot="append">元</template>
        </el-input> -->
        <p v-if="isTotalAmountWaring" style="color: red;line-height: 20px;">合同金额超过20万!!!</p>
      </el-form-item>
      <el-form-item label="用章原因" prop="applyReason">
        <el-input :disabled="type !== 'new'" type="textarea" :rows="5" placeholder="请输入用途" maxlength="200" show-word-limit
          v-model="addInfo.applyReason" />
      </el-form-item>
      <el-form-item label="附件上传" prop="attachmentUrl">
        <!-- 
          :before-upload="beforeAvatarUpload"
          accept="image/jpeg,image/jpg,image/png,application/pdf,application/zip,.zip"
        -->
        <el-upload :class="{
          'avatar-uploader-none': type !== 'new',
        }" :disabled="type !== 'new'" action="" :http-request="httpRequest" :file-list="addInfo.attachmentUrl"
          :on-preview="handlePictureCardPreview" :on-remove="handleRemove" show-file-list>
          <el-button size="small" type="primary" :disabled="type !== 'new'">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <template v-if="addInfo.approvalFlag">
        <el-form-item label="审核状态" prop="status" :rules="{
          required: true, message: '请选择审核状态', trigger: 'change'
        }">
          <el-select v-model="addInfo.status" @change="handleRemark">
            <el-option :value="item.value" :label="item.label" v-for="(item, index) in statusOptions" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="审核原因">
          <el-input type="textarea" :rows="5" maxlength="200" show-word-limit placeholder="请输入审核原因"
            @input="changeMessage($event)" v-model="addInfo.remark" />
        </el-form-item>
      </template>
      <template v-if="type === 'new' || addInfo.status === 0">
        <approvalRadio  v-model="isSubmitApproval" v-show="type === 'new'"/>
        <el-form-item label="下一级审核人" prop="auditPersonId" v-if="activeName == 'queryMine'">
          <el-select v-model="addInfo.auditPersonId" placeholder="请选择" clearable filterable :disabled="type === 'see'">
            <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下一级审核人" prop="auditPersonId" v-else>
            <el-input v-model="this.addInfo.auditPerson" disabled />
          </el-form-item>
      </template>
      <template v-if="activeName == 'queryMyAudit'">
        <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="addInfo.status == '1'">
          <el-radio v-model="addInfo.lastUserFlag" :label="1">是</el-radio>
          <el-radio v-model="addInfo.lastUserFlag" :label="0">否</el-radio>
        </el-form-item>

        <approvalRadio  v-model="isSubmitApproval" v-show="addInfo.status == '1' && addInfo.lastUserFlag == 0"/>

        <el-form-item label="下一级审核人" prop="nextAuditUserName" v-if="addInfo.status == '1' && addInfo.lastUserFlag == 0">
          <el-select v-model="addInfo.nextAuditUserName" placeholder="请选择" clearable filterable>
            <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
            </el-option>
          </el-select>
        </el-form-item>

        <approvalRadio  v-model="isSubmitApproval" v-show="addInfo.status == '3'"/>

        <el-form-item label="转办人" prop="nextAuditUserName" v-if="addInfo.status == '3'">
          <el-select v-model="addInfo.nextAuditUserName" placeholder="请选择" clearable filterable>
            <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
            </el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-form>
    <el-image-viewer v-if="showImg" :url-list="getImageList" :on-close="colseImg" :zIndex="3000"
      :initialIndex="initialIndex" class="img-viewer-row" />
    <review-process :processList="addInfo.auditProcessEntityList" :createTime="addInfo.createTime"
      :createUser="addInfo.applyUser" :auditPerson="addInfo.auditPerson" />
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addEventForm()" v-if="type === 'new'">提 交</el-button>
      <el-button type="primary" @click="addEventForm()" v-else-if="addInfo.approvalFlag">提 交</el-button>
      <el-button type="primary" @click="addStagingForm()"
        v-if="(type === 'new' && addInfo.status === 10) || (type === 'new' && addInfo.status === '')">暂 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { sealList } from '@/utils/constants'
import { listCompanyfInfo } from '@/api/searchList'
import { uploadFile, fileDownload } from '@/api/user'
// import { queryUserInfo } from '@/api/basicInfo'
import { submitApply, getApplyDetail, auditAndNextUser, stagingApply, queryContractStatus } from '@/api/compApplyStamp'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import ReviewProcess from '@/components/ReviewProcess.vue'
import previewDetail from '@/components/Dialog/previewDetail'
import approval from '@/mixins/approval'
import companyDepts from '@/utils/companyDepts.js'
export default {
  mixins: [approval],
  data() {
    return {
      show: false,
      activeName: '',
      type: '',
      id: '',
      companyId: '',
      addInfo: {
        stampType: [],
        applyReason: '',
        eventId: '',
        companyId: '',
        deptName: '',
        relatedContract: '',
        contractCategory: '',
        price: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
        // 审批及审批记录字段
        approvalFlag: false,
        auditPerson: '',
        status: '',
        remark: '',
        createTime: '',
        applyUser: '',
        auditProcessEntityList: [],
        attachmentUrl: [],
      },
      statusOptions: [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
        {
          value: '4',
          label: '退回上一级'
        },
      ],
      sealList: sealList,
      showImg: false,
      initialIndex: 0,
      // userInfoList: [],
      companyValueList: [],
      baseDeptsNameList: ['财务部', '招商部', '综合部', '办公室', '工会', '人事部'],
      deptNameList: [],
      optionsFilter: [],
      rules: {
        stampType: [{ required: true, message: '请选择用章类型', trigger: 'change' }],
        companyId: [{ required: true, message: '请选择公司', trigger: 'change' }],
        applyReason: [{ required: true, message: '请输入用章原因', trigger: 'blur' }],
        nextAuditUserName: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        auditPersonId: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        lastUserFlag: [{ required: true, message: '请选择是否结束审核', trigger: 'change' }],
        contractCategory: [{ required: false, message: '请选择文本类型', trigger: 'change' }],
        price: [{ required: false, message: '请输入总金额', trigger: 'change' }],
      },
      isWarningContract: false,
      isTotalAmountWaring: false,
      categoryOptions: [
        { label: '租赁类' },
        { label: '工程类' },
        { label: '配套类' },
        { label: '审计类' },
        { label: '车辆类' },
        { label: '其它类' }
      ],
      showTotalAmount: false,
      showRelatedContractInput: false,
      // contractList: []
    }
  },
  components: {
    ReviewProcess,
    previewDetail,
    ElImageViewer
  },
  mounted() {
    this.queryList()
    this.getCompanyList()
    this.companyId = JSON.parse(localStorage.getItem('jiadingFangwu_current_company')).companyId
    this.addInfo.companyId = JSON.parse(localStorage.getItem('jiadingFangwu_current_company')).companyId
  },
  computed: {
    getImageList() {
      let imageList = this.addInfo.attachmentUrl.filter((item) => {
        return (item.type === 'jpeg' || item.type === 'jpg' || item.type === 'png')
      }).map(v => v.url)
      return imageList
    },
    getFileList() {
      let fileList = this.addInfo.attachmentUrl.filter((item) => {
        return item.type === 'pdf'
      })
      return fileList
    }
  },
  methods: {
    dataFilter(val) {
      if (val) {
        this.addInfo.deptName = val
        this.deptNameList = this.optionsFilter.filter((item) => {
          if (item.includes(val) || item.toUpperCase().includes(val.toUpperCase())) {
            return true
          } else {
            this.$nextTick(() => {
              this.$refs['addInfo'].clearValidate('deptName')
            })
          }
        })
      } else {
        this.deptNameList = this.optionsFilter
      }
    },
    handleStatus(creatUser) {
      let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
      if (userName === creatUser) {
        this.statusOptions = [
          {
            value: '1',
            label: '通过'
          },
          {
            value: '2',
            label: '拒绝'
          },
          {
            value: '3',
            label: '转办'
          },
        ]
      }
    },
    handleRemark(val) {
      if (val === '1') {
        this.addInfo.remark = '同意'
      } else if (val === '3') {
        this.addInfo.remark = '转办'
      } else {
        this.addInfo.remark = ''
      }
    },
    changeMessage() {
      this.$forceUpdate()
    },
    // 公司下拉框
    async getCompanyList() {
      let res = await listCompanyfInfo({})
      if (res && res.code === 0) {
        this.companyValueList = res.result
        const companyName = this.companyValueList.filter(i => i.companyId === this.companyId)[0].companyName
        if (companyName === '上海荣茂工贸有限公司') {
          this.baseDeptsNameList[1] = '营商服务部'
        }
        const keys = Object.keys(companyDepts)
        if (keys.includes(companyName)) {
          const newDepts = companyDepts[companyName]
          this.deptNameList = [...newDepts, ...this.baseDeptsNameList]
          this.optionsFilter = [...newDepts, ...this.baseDeptsNameList]
        } else {
          this.deptNameList = this.baseDeptsNameList
          this.optionsFilter = this.baseDeptsNameList
        }
      } else {
        this.deptNameList = this.baseDeptsNameList
        this.optionsFilter = this.baseDeptsNameList
      }
    },
    // async queryList() {
    //   let res = await queryUserInfo({
    //     pageNum: 1,
    //     pageSize: 9999,
    //   })
    //   if (res.code === 0) {
    //     this.userInfoList = res.result.records
    //   }
    // },
    showDialog(type = 'new', id = null, activeName) {
      this.type = type
      this.show = true
      this.activeName = activeName
      this.rules.contractCategory[0].required = type === 'new'
      this.rules.price[0].required = type === 'new'
      if (id) {
        this.getDetails(id)
      }
    },
    close() {
      this.show = false
      this.isWarningContract = false
      this.showRelatedContractInput = false
      this.isTotalAmountWaring = false
      this.showTotalAmount = false
      this.addInfo = {
        stampType: [],
        companyId: this.addInfo.companyId,
        applyReason: '',
        deptName: '',
        eventId: '',
        approvalFlag: false,
        auditPerson: '',
        status: '',
        remark: '',
        createTime: '',
        applyUser: '',
        price: '',
        relatedContract: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
        auditProcessEntityList: [],
        attachmentUrl: []
      }
    },
    getDetails(id) {
      this.id = id
      getApplyDetail({
        id
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        console.log((result.attachmentUrl || '').split(','));
        this.companyId = result.companyId
        this.addInfo = {
          auditPerson: result.auditPerson,
          stampType: result.stampType.split(','),
          companyId: result.companyId,
          deptName: result.deptName,
          applyReason: result.applyReason,
          eventId: result.eventId,
          approvalFlag: result.approvalFlag,
          status: result.approvalFlag === true ? '' : result.status,
          remark: '',
          createTime: result.createTime,
          applyUser: result.applyUser,
          auditProcessEntityList: result.auditProcessEntityList,
          lastUserFlag: result.lastUserFlag,
          nextAuditUserName: result.nextAuditUserName,
          auditPersonId: result.auditPersonId,
          attachmentUrl: ((result.attachmentUrl || '').split(',').filter(v => v !== '')).map((item, index) => {
            let name = item?.split('/')
            let type = name[2]?.split('.')[1]
            return {
              fileName: item,
              name: name[name.length - 1],
              url: process.env.VUE_APP_BASE_API + `/minio/getImage?fileName=${item}`,
              code: `attachmentUrl${index}`,
              type: type
            }
          }),
          relatedContract: result.relatedContract,
          contractCategory: result.contractCategory || '',
          price: result.price || ''
        }
        const showTotalAmountTypes = ['工程类', '配套类', '审计类', '其它类']
        if (result.contractCategory === '租赁类') {
          this.showRelatedContractInput = true
          if (result.relatedContract) {
            this.queryContractNature(result.relatedContract)
          }
        } else if (showTotalAmountTypes.includes(result.contractCategory)) {
          this.showTotalAmount = true
          this.totalAmountWaring()
        }
        if (this.type === 'new' && this.addInfo && this.addInfo.auditPersonId && result.status === 10) {
          this.addInfo.auditPersonId = ''
        }
        this.handleStatus(result.createUser)
        if (this.addInfo.companyId === 0) {
          this.addInfo.companyId = null
        } else {
          this.addInfo.companyId = this.addInfo.companyId
        }
        // if (result.attachmentUrl !== '') {
        //   this.addInfo.attachmentUrl = result.attachmentUrl.split(',').map((item, index) => {
        //     let name = item?.split('/')
        //     let type = name[2]?.split('.')[1]
        //     return {
        //       fileName: item,
        //       name: name[name.length - 1],
        //       url: process.env.VUE_APP_BASE_API + `/minio/getImage?fileName=${item}`,
        //       code: `attachmentUrl${index}`,
        //       type: type
        //     }
        //   })
        // }
      })
    },
    addEventForm() {
      console.log(this.addInfo);
      this.$refs.addForm.validate((vaild) => {
        if (vaild) {
          if (this.type === 'new') {
            submitApply({
              applyReason: this.addInfo.applyReason,
              stampType: this.addInfo.stampType.join(','),
              companyId: this.addInfo.companyId,
              deptName: this.addInfo.deptName,
              auditPersonId: this.addInfo.auditPersonId,
              attachmentUrl: (this.addInfo.attachmentUrl || []).map((item) => { return item.fileName }).join(','),
              eventId: this.addInfo.eventId,
              relatedContract: this.addInfo.relatedContract,
              contractCategory: this.addInfo.contractCategory,
              price: this.addInfo.price
            }).then(res => {
              const { code } = res
              if (code !== 0) return
              this.$message.success('申请已提交')
              this.$emit('addSuccess')
              this.close()
            })
          } else if (this.addInfo.approvalFlag) {
            auditAndNextUser({
              id: this.id,
              remark: this.addInfo.remark,
              status: this.addInfo.status,
              lastUserFlag: this.addInfo.lastUserFlag,
              nextAuditUserName: this.addInfo.nextAuditUserName,
            }).then(res => {
              const { code } = res
              if (code !== 0) return
              this.$message.success('审批成功！')
              this.$emit('addSuccess')
              this.close()
            })
          }
        }
      })
    },
    async addStagingForm() {
      this.$refs.addForm.validate(async (vaild) => {
        if (vaild) {
          const { code, message } = await stagingApply({
            applyReason: this.addInfo.applyReason,
            stampType: this.addInfo.stampType.join(','),
            companyId: this.addInfo.companyId,
            deptName: this.addInfo.deptName,
            auditPersonId: this.addInfo.auditPersonId,
            attachmentUrl: (this.addInfo.attachmentUrl || []).map((item) => { return item.fileName }).join(','),
            eventId: this.addInfo.eventId,
            relatedContract: this.addInfo.relatedContract,
            contractCategory: this.addInfo.contractCategory,
            price: this.addInfo.price
          })
          if (code !== 0) {
            this.$message.error(message)
            return
          }
          this.$message.success('暂存成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
    // 文件上传
    async httpRequest(param) {
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      const { code, result, message } = await uploadFile(fd)
      if (code === 0) {
        let name = result.split('/')
        let type = name[2].split('.')[1]
        this.addInfo.attachmentUrl.push({
          fileName: result,
          name: name[name.length - 1],
          url: process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + result,
          code: result,
          type: type
        })
        this.$refs.addForm.validateField('attachmentUrl')
      } else {
        this.$message.error(message)
      }
    },
    // // 上传前文件格式校验
    // beforeAvatarUpload (file) {
    //    // 格式过滤
    //   let fileType = ['png', 'jpg', 'jpeg', 'pdf', 'zip'] 
    //   let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
    //   const extension = fileType.indexOf(testmsg) >= 0
    //   if (!extension) {
    //     this.$message.error('仅支持png, jpg, jpeg, pdf, zip格式')
    //   }
    //   return extension
    // },
    // 图片预览
    async handlePictureCardPreview(file) {
      if (this.isTypeImage(file)) {
        this.showImg = true
        this.initialIndex = this.getImageList.indexOf(file.url) > -1 ? this.getImageList.indexOf(file.url) : 0
      } else {
        let componentProps = {
          curStatus: '',
          pdfFile: file
        }
        let dialogProps = {
          title: '文件预览', 
          width: '80%', 
          footer: true
        }
        if (['pdf', 'PDF'].includes(file.type)) {
          componentProps.curStatus = 'pdf'
          this.$dialog(previewDetail, componentProps, dialogProps)
          return
        }
        if (['doc', 'docx'].includes(file.type)) {
          componentProps.curStatus = 'doc'
          this.$dialog(previewDetail, componentProps, dialogProps)
          return
        }
        if (['xlsx', 'xls'].includes(file.type)) {
          componentProps.curStatus = 'xls'
          this.$dialog(previewDetail, componentProps, dialogProps)
          return
        }
        let res = await fileDownload(file.url.split('=')[1])
        let blob = new Blob([res.data], { type: res.data.type })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = file.name
        link.click()
      }
      // let fileType = ['png', 'jpg', 'jpeg'] 
      // let imageList = this.getImageList.find((item) => {
      //   let testmsg = item.name.substring(item.name.lastIndexOf('.') + 1)
      //   const extension = fileType.indexOf(testmsg) >= 0
      //   if (extension) return item
      // })
      // if (imageList)
      // this.initialIndex = this.getImageList.indexOf(row.url) > -1 ? this.getImageList.indexOf(row.url) : 0
      // this.showImg = true
    },
    isTypeImage(item) {
      if (item.type === 'jpeg' || item.type === 'jpg' || item.type === 'png') {
        return true
      }
    },
    colseImg() {
      this.showImg = false
    },
    // 图片删除
    handleRemove(row) {
      this.addInfo.attachmentUrl = this.addInfo.attachmentUrl.filter((item) => item.url !== row.url)
    },
    async queryContractNature(relatedContract = '') {
      if (!relatedContract) return
      const res = await queryContractStatus({ contractNumber: relatedContract })
      if (res && res.code === 0) {
        this.isWarningContract = res.result
      } else {
        this.addInfo.relatedContract = ''
        this.isWarningContract = false
      }
    },
    categoryChange (val) {
      const showTotalAmountTypes = ['工程类', '配套类', '审计类', '其它类']
      this.showRelatedContractInput = val === '租赁类'
      this.showTotalAmount = showTotalAmountTypes.includes(val)
      this.resetForm()
      // if (val === '租赁类') {
      //   if (this.contractList.length > 0) return
      //   queryContracts(val).then(res => {
      //     const { code, result = [] } = res
      //     if (code === 0 && result) {
      //       this.contractList = result.map(item => {
      //         return { label: item.filingNumber }
      //       })
      //     }
      //   })
      // }
      // if (val === '租赁类') {
      //   // 显示关联合同input && 查询相关合同号
      //   this.showRelatedContractInput = true
      // }
      // if (showTotalAmountTypes.includes(val)) {
      //   this.showTotalAmount = true
      // }
    },
    totalAmountWaring () {
      const { price } = this.addInfo
      this.isTotalAmountWaring = price && Number(price) > 200000
      // if (totalAmount && Number(totalAmount) > 200000) {
      //   this.isTotalAmountWaring = true
      // } else {
      //   this.isTotalAmountWaring = false
      // }
    },
    resetForm () {
      this.isTotalAmountWaring = false
      this.isWarningContract = false
      this.addInfo.relatedContract = ''
      this.addInfo.price = ''
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  min-width: 500px;
  width: 30%;

  .el-dialog__body {
    max-height: 50vh;
    overflow-y: scroll;
  }
}
</style>